__turbopack_context__.v({
  "banner": "styles-module__RPRhUq__banner",
  "content": "styles-module__RPRhUq__content",
  "description": "styles-module__RPRhUq__description",
  "image": "styles-module__RPRhUq__image",
  "imageContainer": "styles-module__RPRhUq__imageContainer",
  "imageFill": "styles-module__RPRhUq__imageFill",
  "openBtn": "styles-module__RPRhUq__openBtn",
  "textContent": "styles-module__RPRhUq__textContent",
  "title": "styles-module__RPRhUq__title",
});
